import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const subscriptionTierSchema = z.enum(["FREE", "PRO", "ULTIMATE"]);

export const subscriptionStatusSchema = z.enum([
  "ACTIVE",
  "CANCELED",
  "PAST_DUE",
  "TRIALING",
  "INCOMPLETE",
]);

export const subscriptionSchema = z.object({
  tier: subscriptionTierSchema,
  status: subscriptionStatusSchema,
  lsSubscriptionId: z.number().nullable().optional(),
  lsCurrentPeriodEnd: z.string().nullable().or(z.date()).optional(),
});

export class SubscriptionDto extends createZodDto(subscriptionSchema) {}
